"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsBigScreen = void 0;
var appStylesBase_1 = require("../../styles/appStylesBase");
var getWindowWidth_1 = require("./getWindowWidth");
var getIsBigScreen = function (_a) {
    var state = _a.state;
    var windowWidth = (0, getWindowWidth_1.getWindowWidth)({ state: state });
    return windowWidth >= (0, appStylesBase_1.appStylesBase)().widthBreakpoints.big + 32; // add cushion
};
exports.getIsBigScreen = getIsBigScreen;
